import { Grid, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import NivelDesarrolloCompetencia from "../../components/Form/Fields/NivelDesarrolloCompetencia";
import SituacionSignificativa from "../../components/Form/Fields/SituacionSignificativa";
import TemaClase from "../../components/Form/Fields/TemaClase";
import TiempoClase from "../../components/Form/Fields/TiempoClase";
import ClaseActivaCardImg from "../../components/UmmIApps/Cards/ClaseActivaCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const ClaseActivaPeruPage = () => {
  const [nivelId, setNivelId] = useState(null); // Estado para el nivel seleccionado

  const {
    materiaId,
    setPromptData,
    promptData,
    handleAsignaturaChange,
    handleBack,
    setTextoInicial,
    isOAAdded,
    handleInitialPromptData,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema &&
    promptData.tiempo_clase &&
    isOAAdded
  );
  const colorIconBack = "#278C62";

  // Callback para actualizar promptData con el nivel
  const handleNivelChange = (nivelNombre: any, nivelId: any) => {
    console.log("Nivel seleccionado:", nivelNombre, nivelId);
    setPromptData((prev: any) => ({
      ...prev,
      nivel: nivelNombre, // Guarda el nombre del nivel
    }));
    setNivelId(nivelId); // Guarda el id para usar en GetAsignaturas
  };

  // Ejemplo de callback para asignatura (si aún no lo tienes definido)
  const handleAsignaturaChangeLocal = (asignatura: any) => {
    console.log("Asignatura seleccionada:", asignatura);
    setPromptData((prev: any) => ({
      ...prev,
      materia: asignatura.nombre, // O asignatura.id, según lo que requieras
    }));
    // Si ya tienes handleAsignaturaChange desde el context, asegúrate de llamarlo también:
    handleAsignaturaChange(asignatura);
  };

  useEffect(() => {
    const init = {
      tema: "",
      caracterizacion: "",
      condiciones_contexto: "",
      tiempo_clase: 45,
      situacion_significativa: "",
      nivel_desarrollo_competencia: "",
    };
    handleInitialPromptData(init, "clase_activa_peru");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Recuerda que puedes ajustar los parámetros en 'Mostrar campos', solicitar una nueva propuesta a UmmIA, o personalizar el contenido según tus necesidades."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ClaseActivaCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        }
        titleColor="#278C62"
        title="Clase Activa"
        description="Diseña clases dinámicas y participativas que involucren a los estudiantes en su propio proceso de aprendizaje, fomentando la participación y el interés por la materia."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ m: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ m: 2, mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper elevation={3} sx={{ p: 5, mb: 4 }}>
            <GetObjetivosAprendizaje
              nombreAsignatura={promptData.materia}
              nombreNivel={promptData.nivel}
            />
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <TemaClase />
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <TiempoClase promptData={promptData} setPromptData={setPromptData} />
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <SituacionSignificativa />
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <NivelDesarrolloCompetencia />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <CondicionesContexto />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Caracterizacion />
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default ClaseActivaPeruPage;
